import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditLanguageModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayFormField } from "commons/fields";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import {CreateLanguageRequest, EditLanguageRequest} from "models/request";


const CreateAndEditLanguageModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caelm-name-required-msg",
        message: "È necessario inserire un nome per poter modificare la lingua"
    })),
    engName: Yup.string().required(t({
        id: "caelm-eng-name-required-msg",
        message: "È necessario inserire la traduzione inglese per poter modificare la lingua"
    })),
    /*isoCode: Yup.string().required(t({
        id: "caelm-iso-code-required-msg",
        message: "È necessario inserire il codice ISO 639-1 per poter modificare la lingua"
    })).max(3),*/
});

class CreateAndEditLanguageModal extends React.Component<CreateAndEditLanguageModalProps & UseFormReturn, {}>
{

    componentDidMount(){
        if(this.props.language){
            this.props.setValue("name", this.props.language.value);
            this.props.setValue("engName", this.props.language.engName);
            this.props.setValue("isoCode", this.props.language.isoCode);
        }
    }

    private onSubmit = (values: any) => {
        if(this.props.language){
            this.editLanguage(values);
        } else {
            this.createLanguage(values);
        }
    }

    private editLanguage = (values: any) => {

        let request: EditLanguageRequest = {
            value: values.name,
            engName: values.engName,
            isoCode: values.isoCode
        }

        ContentProducerService.editLanguage(this.props.language!.id, request, this.props.editLanguageCallback, this.props.editLanguageErrorCallback)
    }

    private createLanguage = (values: any) => {

        let request: CreateLanguageRequest = {
          value: values.name,
          engName: values.engName,
          isoCode: values.isoCode
        }

        ContentProducerService.createLanguage(request, this.props.createLanguageCallback, this.props.createLanguageErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.language? <Trans id="caelm-edit-title">Modifica lingua</Trans> : <Trans id="caelm-create-title">Aggiungi lingua</Trans>}
                </DialogTitle>
                <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caelm-language-name-label">Inserisci la lingua e il suo codice secondo lo standard ISO 639-1.</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caelm-name",
                                message: "Lingua"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                        <ZPlayFormField
                            label={t({
                                id: "caelm-eng-name",
                                message: "Lingua in inglese"
                            })}
                            name="engName"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                        <ZPlayFormField
                            label={t({
                                id: "caelm-iso-code",
                                message: "Codice ISO 639-1"
                            })}
                            name="isoCode"
                            maxValue={3}
                            //required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                            disabled={!!this.props.language}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caelm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="submit"
                            disabled={this.props.formState.isSubmitting}>
                            {this.props.language ? <Trans id="caelm-edit-btn">Modifica</Trans> : <Trans id="cl-create-btn">Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditLanguageModal, CreateAndEditLanguageModalSchema, {});
